// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"024562ec","952":"60714c49"}[chunkId] + ".chunk.js";
};